import { render } from "./InitialLoader.vue?vue&type=template&id=99505cd8&scoped=true"
import script from "./InitialLoader.vue?vue&type=script&lang=js"
export * from "./InitialLoader.vue?vue&type=script&lang=js"

import "./InitialLoader.vue?vue&type=style&index=0&id=99505cd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99505cd8"]])

export default __exports__